import type { FC } from 'react';
import React from 'react';

import type { IconColor } from '@atlaskit/tokens/css-type-schema';

import { Grid24Icon } from './images/Grid24Icon';

type GridIconProps = {
	label: string;
	primaryColor?: IconColor;
	testId?: string;
};

export const GridIcon: FC<GridIconProps> = ({ label, primaryColor, testId }) => {
	return React.createElement(Grid24Icon, {
		label,
		testId,
		primaryColor,
	});
};
